<template>
    <div>
        <Hero />
        <Services />
        <Portfolio />
    </div>
</template>

<script>
export default {
    name: "home",
    components: {
        Hero: () => import("../components/Hero.vue"),
        Services: () => import("../components/Services.vue"),
        Portfolio: () => import("../components/Portfolio.vue")
    }
};
</script>
